import { render, staticRenderFns } from "./GridTabsExperience.vue?vue&type=template&id=120715d9&scoped=true"
import script from "./GridTabsExperience.vue?vue&type=script&lang=js"
export * from "./GridTabsExperience.vue?vue&type=script&lang=js"
import style0 from "./GridTabsExperience.vue?vue&type=style&index=0&id=120715d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120715d9",
  null
  
)

export default component.exports